import React from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { EASEMENTS_COVENANTS_CONDITIONS_RESTRICTIONS } from '../../../../constants';
import InlineTooltip from '../../../Widgets/InlineTooltip';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function EasementsCovenantsConditionsAndRestrictions({ section, setSectionValues }: Props) {
  function onNoECCR(): void {
    setSectionValues({
      [EASEMENTS_COVENANTS_CONDITIONS_RESTRICTIONS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesECCR(): void {
    setSectionValues({
      [EASEMENTS_COVENANTS_CONDITIONS_RESTRICTIONS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  const EECRActive = section.getFieldValue(EASEMENTS_COVENANTS_CONDITIONS_RESTRICTIONS.FIELD_NAME.IS_ENABLED);

  return (
    <FormField
      label={
        <Label size="lg">
          Do any{' '}
          <InlineTooltip tooltipBodyText="Easements, covenants, conditions, or restrictions are contractual or statutory obligations placed on the property. Your property title will often list any easements or covenants on the property. These obligations are separate from HOA or condo rules.">
            easements, covenants, conditions, or restrictions
          </InlineTooltip>{' '}
          apply to the property?
        </Label>
      }
      control={<YesAndNo yesHandler={onYesECCR} noHandler={onNoECCR} yesActive={EECRActive} />}
      description={
        EECRActive && (
          <FormHelp>
            You must provide the tenant copies of any easements, covenants, conditions, or restrictions before the lease
            is signed by tenant
          </FormHelp>
        )
      }
    />
  );
}
